import type { LngLatLike } from 'mapbox-gl';

export const LOCATIONS_SOURCE = 'locations';
export const LOCATIONS_LAYER_JOINED = 'locations_joined';
export const LOCATIONS_LAYER_NOT_JOINED = 'locations_not_joined';
export const LOCATIONS_CLUSTER = 'locations_cluster';
export const LOCATIONS_CLUSTER_COUNT = 'locations_cluster_count';

export const defaultCoords: LngLatLike = [23.7724444, 61.4988056]; // center of Tampere
export const DEFAULT_INSTANCE_ZOOM = 13;
